import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'
import { EVENT_VIEWS } from '~/constants'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchEventCategories ({ commit }) {
      await platformAction({
        client: this.$api.events.categories,
        method: 'getAll',
        commit,
        logError: this.$logError
      })
    }
  },
  getters: {
    ...platformGetters,
    eventCategories: s => s.data,
    eventCategoriesByType: s => eventView => {
      const { eventTypes } = EVENT_VIEWS[eventView]
      return Object.values(s.data).filter(e => e.eventTypes.some(t => eventTypes.includes(t)))
    }
  },
  mutations: {
    ...platformMutations
  }
}
